import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { FontFamily, TypographyProvider } from '@lili/lili-frontend-common';
import { useBoundStore } from '@Store/useBoundStore';
import { queryClient } from './queryClient.ts';
import './in18/in18.ts';
import App from './App';

export const InitApp = () => {
  useEffect(() => {
    useBoundStore.getState().setIsHydrated(true);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TypographyProvider defaultFontFamily={FontFamily.INTER}>
        <App />
      </TypographyProvider>
    </QueryClientProvider>
  );
};
